import React from "react"

const MessagesPage = () => {
  return <div className="page">Messages Page</div>
}

export default MessagesPage
